'use client'

import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { segmentEventCommonPropFunc } from '@utils/segmentProperties'
import Link from 'next/link'
import styles from './onecolumnwidth.module.scss'

const ClickWrapper = ({
  redirectionUrl,
  opensTab = false,
  customProperties,
  segmentEventCommonProperties = undefined,
}: {
  redirectionUrl: string
  opensTab?: boolean
  customProperties?: Record<string, any>
  segmentEventCommonProperties?: any
}) => {
  const onImageClick = async () => {
    const defaultProperties = await segmentEventCommonPropFunc(segmentEventCommonProperties)
    await trackEvent('tap_btn_CTA_widget', {
      ...defaultProperties,
      journey: 'inline_cta_click',
      ...(customProperties || {}),
    })
  }

  return (
    <Link
      className={styles.clickWrapperStyles}
      onClick={() => {
        void onImageClick()
      }}
      href={redirectionUrl}
      target={opensTab ? '_blank' : '_self'}
    />
  )
}

export default ClickWrapper
